<template>
  <div class="cf-app-layout__sticky-bottom-container">
    <button
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      type="button"
      @click="handleClick"
    >
      {{ buttonText }}
    </button>
  </div>
</template>


<script>
  import { mapGetters, mapState } from 'vuex';

  import { goToOrderAtTableCart } from '@/services/navigation/go-to-order-at-table-cart';


  export default {
    name: 'CfOrderAtTableFloatingAction',

    computed: {
      ...mapGetters('orders', ['order']),
      ...mapGetters('session', ['session']),

      ...mapState('orders', {
        stateOrder: 'order'
      }),

      hasStagedItems() {
        return this.order.orderItemStagedCount > 0;
      },

      hasOrderItems() {
        return this.order.orderItemCount > 0;
      },

      buttonText() {
        if (this.hasStagedItems) {
          return 'Send Order';
        }

        return 'Pay Tab';
      }
    },

    methods: {
      handleClick() {
        if (this.hasStagedItems) {
          goToOrderAtTableCart();
        }
        else {
          this.goToCheckoutPage();
        }
      },

      goToCheckoutPage() {
        const orderId = this.order.orderId || this.stateOrder.orderId;

        this.$router.push({
          name: 'payAtTableCheckout',
          params: {
            merchantId: this.$route.params.merchantId
          },
          query: {
            ml: this.session.route.merchantLocationId,
            oi: orderId,
            tb: this.session.route.tableNumber
          }
        });
      }
    }
  };
</script>
